import { BookOpenCheck } from "lucide-react";
import { defineModuleUi } from "@vixio/data";
import { lazyPage } from "@vixio/ui";
import "./api";

export * from "./api";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const CasesPage = lazyPage(() => import("./CasesPage"), "CasesPage");
const CasePage = lazyPage(() => import("./CasePage"), "CasePage");

export default defineModuleUi({
  key: "cases",
  title: "Casos",
  domain: "content",
  icon: BookOpenCheck,
  menu: [{ path: "/conteudo/casos", label: "Casos", minRole: "member", icon: BookOpenCheck, order: 60, keywords: "caso autorização publicação depoimento vitrine" }],
  routes: [
    { path: "/conteudo/casos", element: <CasesPage />, minRole: "member" },
    { path: "/conteudo/casos/:id", element: <CasePage />, minRole: "member" },
  ],
});
